import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext } from "react";
import getDisplayName from "react-display-name";
import hoistNonReactStatics from "hoist-non-react-statics";
import { jsx as ___EmotionJSX } from "@emotion/react";
var HostContext = /*#__PURE__*/React.createContext("");
export var useHost = function useHost() {
  return useContext(HostContext);
};
export var withHost = function withHost(Page) {
  var WithHost = function WithHost(props) {
    return ___EmotionJSX(HostContext.Provider, {
      value: (props === null || props === void 0 ? void 0 : props.host) || ""
    }, ___EmotionJSX(Page, props));
  };

  hoistNonReactStatics(WithHost, Page);
  WithHost.displayName = "withHost(".concat(getDisplayName(Page), ")");

  WithHost.getInitialProps = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
      var _ctx$req;

      var headers, host, cleanedHost, pageProps;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              headers = (_ctx$req = ctx.req) === null || _ctx$req === void 0 ? void 0 : _ctx$req.headers;
              host = (headers === null || headers === void 0 ? void 0 : headers["x-forwarded-host"]) || (headers === null || headers === void 0 ? void 0 : headers.host) || "";
              cleanedHost = host ? host.split(":")[0] : "";
              _context.t0 = Page.getInitialProps;

              if (!_context.t0) {
                _context.next = 8;
                break;
              }

              _context.next = 7;
              return Page.getInitialProps(ctx);

            case 7:
              _context.t0 = _context.sent;

            case 8:
              pageProps = _context.t0;
              return _context.abrupt("return", _objectSpread(_objectSpread({}, pageProps), {}, {
                host: cleanedHost
              }));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return WithHost;
};